import { render, staticRenderFns } from "./carregarfoto.vue?vue&type=template&id=3a8b4132&"
import script from "./carregarfoto.vue?vue&type=script&lang=js&"
export * from "./carregarfoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports